import React from 'react'
import Messenger from '../../component/chat/Messenger';

function Chat() {
    return (
        <div>
            <Messenger />
        </div>
    );
}
export default Chat
